import React, { useEffect } from 'react';
import CruiseSearch from '../cruiseComponents/CruiseSearch';
import GridCruiseList from '../cruiseComponents/GridCruiseList';

const BookNow = () => {
  useEffect(() => {
    if (window.google && window.google.maps) {
      // Your Google Maps initialization code here
    }
  }, []);

  const handleSearch = (searchParams) => {
    console.log('Search clicked:', searchParams);
    // Add your search logic here
  };

  const cruises = [];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-extrabold text-gray-900">
            Find Your Virgin Voyage
          </h2>
          <p className="mt-4 text-xl text-gray-600 font-['VVCentra2']">
            Discover our most popular and unique sailing experiences
          </p>
        </div>

        {/* <div className="flex justify-center">
          <CruiseSearch onSearch={handleSearch} />
        </div> */}

        <div>
          <GridCruiseList cruises={cruises}/>
        </div>
      </div>
    </section>
  );
};

export default BookNow;
